<template>
  <el-dialog title="添加数据" :visible.sync="show" width="80%" custom-class="json-list-setter-dialog" append-to-body>
    <el-table :data="datas" stripe border size="mini">
      <el-table-column :label="column.name" :width="column.width" v-for="column in columns" :key="column.name">
        <template slot-scope="scope">
          <el-input v-if="column.type === 'dict'" size="mini" placeholder="请选择字典" v-model="scope.row[column.field + '_text']">
            <el-button slot="append" @click="toSelect('dictSelectDialog', scope.$index, column.field)" size="mini">选择字典</el-button>
          </el-input>
          <el-input v-else-if="column.type === 'data'" size="mini" placeholder="请选择数据源" v-model="scope.row[column.field + '_text']">
            <el-button slot="append" @click="toSelect('dataSourceSelectDialog', scope.$index, column.field)" size="mini">选择数据源</el-button>
          </el-input>
          <el-input v-else-if="column.type === 'textarea'" size="mini" type="textarea" v-model="scope.row[column.field]"></el-input>
          <template v-else>
            <el-select v-model="scope.row[column.field]" size="mini" v-if="column.values">
              <el-option v-for="item in column.values" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="scope.row[column.field]" size="mini" v-else></el-input>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="92px">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button size="mini" type="primary" @click="doAdd" style="float:left">添 加</el-button>
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="doSave">确 定</el-button>
    </div>
    <dict-select-dialog ref="dictSelectDialog" @save="setDict"></dict-select-dialog>
    <data-source-select-dialog ref="dataSourceSelectDialog" dataType="LIST" :configColumn="false" :configCondition="false" :configOperation="false" @save="setDataSource" :endpoint="endpoint" :uiId="uiId"></data-source-select-dialog>
  </el-dialog>
</template>

<script>
import DictSelectDialog from './DictSelectDialog'
import DataSourceSelectDialog from '../model/DataSourceSelectDialog'

export default {
  name: 'json-list-setter-dialog',
  components: {
    DictSelectDialog,
    DataSourceSelectDialog
  },
  props: {
    endpoint: { type: String, required: true },
    uiId: { type: Number, required: true }
  },
  data () {
    return {
      show: false,
      datas: [],
      columns: [],
      currentIndex: 0,
      currentField: null
    }
  },
  methods: {
    open (columns, datas) {
      let temp = JSON.parse(JSON.stringify(datas || []))
      if (temp.length === 0) {
        temp.push({})
      }
      this.datas = temp
      this.columns = columns
      this.show = true
    },
    deleteRow (index) {
      this.datas.splice(index, 1)
    },
    doAdd () {
      this.datas.push({})
    },
    doSave () {
      let result = []
      let datas = this.datas
      for (let data of datas) {
        let hasOwnProperty = false
        for (let f in data) {
          if (data.hasOwnProperty(f)) {
            hasOwnProperty = true
            break
          }
        }

        if (hasOwnProperty) {
          result.push(data)
        }
      }
      this.$emit('save', result)
      this.show = false
    },
    toSelect (refDialog, index, field) {
      this.currentIndex = index
      this.currentField = field
      this.$refs[refDialog].open()
    },
    setDict (dict) {
      let dictName = dict.name
      delete dict.name

      let row = this.datas[this.currentIndex]
      this.$set(row, this.currentField, JSON.stringify(dict))
      this.$set(row, this.currentField + '_text', dictName)
    },
    setDataSource (dataSource) {
      let name = dataSource.name
      delete dataSource.name

      let row = this.datas[this.currentIndex]
      this.$set(row, this.currentField, JSON.stringify(dataSource))
      this.$set(row, this.currentField + '_text', name)
    }
  }
}
</script>

<style>
.json-list-setter-dialog .el-dialog__body{padding:0;margin-top:10px;}
</style>
